/**
 * Width at which `asc-navbar` swaps its inline desktop row for the hamburger
 * drawer, and `asc-nav-item` swaps its dropdown panel for an inline accordion.
 */
export const MOBILE_BREAKPOINT_PX = 1024;
